import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import VideoState from '../../../shared/stores/root-store/video.state';
import {VideoUserVolumeUpdateAction} from '../../../shared/stores/root-store/actions/timeline.action';
import {selectUserVolumeFromState} from '../../../shared/stores/root-store/selectors/video.selector';
import {ClickOutsideEvent} from '../../../shared/interfaces/click-outside-event.interface';

@Component({
    selector: 'eocm-volume',
    templateUrl: './volume.component.html',
    styleUrls: ['./volume.component.scss']
})

export class VolumeComponent implements OnInit {
    openSlider = false;
    volume = 100;
    isVolumeMuted = false;
    lastVolumeBeforeMute: number;
    timeoutForHideSlider: NodeJS.Timer;
    timeoutForSlideOut: NodeJS.Timer;
    isSlideOutAnimationAllowed: boolean;

    @ViewChild('volumeControlToggle') volumeControlToggle: ElementRef;

    constructor(private store: Store<{ video: VideoState }>) {
    }

    ngOnInit() {
        this.store.select(selectUserVolumeFromState).subscribe(volume => this.volume = volume);
    }

    hideSlider() {
        this.openSlider = false;
    }

    changeVolume(volume: number) {
        this.store.dispatch(VideoUserVolumeUpdateAction({
            changedUserVolume: volume
        }));
    }

    handleClickOutside(clickedOutside: ClickOutsideEvent) {
        if (clickedOutside.clickedOutside && clickedOutside.clickedElement !== this.volumeControlToggle.nativeElement) {
            this.openSlider = false;
        }
    }

    muteVolume() {
        if (this.volume) {
            this.lastVolumeBeforeMute = this.volume;
            this.changeVolume(0);
            this.isVolumeMuted = true;

            return;
        }

        if (this.isVolumeMuted && !this.volume) {
            this.changeVolume(this.lastVolumeBeforeMute);
            this.isVolumeMuted = false;

            return;
        }
    }

    clearSliderTimeouts() {
        clearTimeout(this.timeoutForHideSlider);
        clearTimeout(this.timeoutForSlideOut);

        this.isSlideOutAnimationAllowed = false;
    }

    closeSliderAfterTime() {
        this.timeoutForSlideOut = setTimeout(() => {
            this.isSlideOutAnimationAllowed = true;
        }, 1300);

        this.timeoutForHideSlider = setTimeout(() => {
            this.hideSlider();
        }, 1500);
    }
}
